/**
 * Created by jacmai on 2/27/2017.
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/actions/actionGroup/actionGroupView",
  "modules/actions/actionGroup/actionGroupInfo/actionGroupInfoModule",
  "modules/actions/actionGroup/actionGroupItems/actionGroupItemsModule",
], function (
  Marionette,
  Messenger,
  ActionGroupView,
  ActionGroupInfoModule,
  ActionGroupItemsModule,
) {
  var ActionGroupController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "actiongroup";
      this._setUpVents();
    },
    show: function (actionGroup) {
      this.layout = new ActionGroupView.actionGroupLayout();
      this.info = this.addSubModule(
        new ActionGroupInfoModule({ region: this.layout.actionGroupInfo }),
      );
      this.items = this.addSubModule(
        new ActionGroupItemsModule({ region: this.layout.actionGroupItems }),
      );
      //if the action group is deleted, then reset the region
      this.listenToOnce(
        actionGroup,
        "destroy",
        function () {
          this.region.reset();
        },
        this,
      );
      this.layout.on(
        "show",
        function () {
          this._showSubViews(actionGroup);
        },
        this,
      );
      this.showRegion(this.layout);
    },
    _showSubViews: function (actionGroup) {
      this.info.show(actionGroup);
      this.items.show(actionGroup);
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "action:list:item:selected",
        function (actionGroup) {
          this.show(actionGroup);
        },
        this,
      );
    },
  });

  return ActionGroupController;
});
